
export default class PromiseData {
  /**
   * @type {Number}
   */
  // TODO: maybe change to save parentTraceId
  parentContextId;
  /**
   * @type {Number}
   */
  promiseId;
  /**
   * @type {Number}
   */
  parentPromiseId;
  /**
   * @type {Number}
   */
  callbackContextId;
}